const handleInterest = () => {
  $('.form--account').on('change', '.list-interest input', function() {
    const $this = $(this);
    const $listInterest = $this.closest('.list-interest');
    const $form = $this.closest('.form--account');
    const $tagsField = $form.find('[name="customer[tags]"]');
    let tagString = '';

    $listInterest.find('li').each(function() {
      const $this = $(this);
      const $input = $this.find('input');

      if ($input.prop('checked')) {
        tagString = tagString + ',' + $input.val();
      }
    });

    $tagsField.val(tagString);
  });
}

handleInterest();
